export const formatPhoneNumber = (phoneNumber) => {
    if (phoneNumber && phoneNumber.length === 10) {
        return `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, 10)}`
    }
    return phoneNumber;
};